export default "__VITE_ASSET__CyNDGnRE__"